import { oncallFetch } from "sc/backend/oncall/fetch-helper";

export default function*() {
  return yield oncallFetch("/api/oncall/administration/partners/list", {});
}



// WEBPACK FOOTER //
// ./src/sc/backend/oncall/administration/partners/list.js